import { UserRole } from "imagine-users";
import { Address, DefectStatus, DefectType } from "..";

const getDefectStatusText = (status: DefectStatus): string => {
  switch (status) {
    case DefectStatus.OPEN:
      return "Mangel";
    case DefectStatus.IN_PROGRESS:
      return "I gang med udbedring";
    case DefectStatus.APPROVED:
      return "Godkendt";
    case DefectStatus.REJECTED:
      return "Afvist";
    default:
      return "";
  }
};

const getRoleText = (role: UserRole) => {
  switch (role) {
    case UserRole.ADMIN:
      return "Administrator";
    case UserRole.MODERATOR:
      return "Rådgiver";
    case UserRole.PREMIUM:
      return "Entreprenør";
    case UserRole.NONE:
      return "Beboer";
    default:
      return "Ukendt";
  }
};

const getDefectTypeText = (type: DefectType) => {
  switch (type) {
    case DefectType.DEFAULT:
      return "Standard";
    case DefectType.PRE_REGISTRATION:
      return "Før-registrering";
    case DefectType.INSPECTION:
      return "Tilsyn";
    default:
      return "Ukendt";
  }
};

const getRoleTextNoAdmin = (role: UserRole) => {
  switch (role) {
    case UserRole.ADMIN:
    case UserRole.MODERATOR:
      return "Rådgiver";
    case UserRole.PREMIUM:
      return "Entreprenør";
    case UserRole.NONE:
      return "Beboer";
    default:
      return "Ukendt";
  }
};

const parseCsv = (text: string, projectId: number) => {
  const rows = text.replace(/\r/g, "").split("\n");
  const header = rows[0].split(";");
  // Find inde of address column
  const addressIndex = header.findIndex((col) => col === "Adresse");
  const nameIndex = header.findIndex((col) => col === "Navn");
  const emailIndex = header.findIndex((col) => col === "Email");
  const phoneIndex = header.findIndex((col) => col === "Telefon");
  const name2Index = header.findIndex((col) => col === "Navn 2");
  const email2Index = header.findIndex((col) => col === "Email 2");

  const maxIndex = Math.max(addressIndex, nameIndex, emailIndex, phoneIndex);

  console.log("Header", header);

  console.log("Address index", addressIndex);
  console.log("Name index", nameIndex);
  console.log("Email index", emailIndex);
  console.log("Phone index", phoneIndex);
  console.log("Name2 index", name2Index);
  console.log("Email2 index", email2Index);

  const addresses: Address[] = [];
  for (let i = 1; i < rows.length; i++) {
    const cols = rows[i].split(";");
    if (cols.length > maxIndex) {
      const address: Address = {
        id: 0,
        name: cols[addressIndex],
        projectId: projectId,
        residentEmail: cols[emailIndex].trim(),
        residentPhone: cols[phoneIndex].trim(),
        residentName: cols[nameIndex].trim(),
        residentName2: cols[name2Index].trim(),
        residentEmail2: cols[email2Index].trim(),
        deadline: null,
        approved: false,
      };
      addresses.push(address);
    }
  }
  return addresses;
};

export const PunchlistText = {
  getDefectStatusText,
  getRoleText,
  getDefectTypeText,
  getRoleTextNoAdmin,
  parseCsv,
};
